import React, { Component } from "react";
const $ = window.$;

var allSet = false;

export default class RemoteComplete extends Component {
    constructor(props) {
        super(props);
        this.interceptClick = this.interceptClick.bind(this);
        this.stressLevelChange = this.stressLevelChange.bind(this);
        this.cooperationChange = this.cooperationChange.bind(this);
        this.computerSkillChange = this.computerSkillChange.bind(this);
        this.state = {
            stressLevelValue: 0,
            cooperationValue: 0,
            computerSkillValue: 0
        };
    }

    componentDidMount() {
        this.afterUpdate();
    }

    componentDidUpdate() {
        this.afterUpdate();
    }

    afterUpdate() {
        this.props.setInterceptClick(this.interceptClick);

        if (!allSet && this.state.stressLevelValue > 0 && this.state.cooperationValue > 0 && this.state.computerSkillValue > 0) {
            allSet = true;
            this.props.clearDisableNext();
        }
    }

    stressLevelChange(value) {
        this.setState({ stressLevelValue: value });
    }

    cooperationChange(value) {
        this.setState({ cooperationValue: value });
    }

    computerSkillChange(value) {
        this.setState({ computerSkillValue: value });
    }

    interceptClick(type) {
        if (type === "next") {
            const response = {
                stressLevel: this.state.stressLevelValue,
                cooperation: this.state.cooperationValue,
                computerSkill: this.state.computerSkillValue,
                notes2: $("#notes2").val()
            };

            this.props.next(response);
            return true;
        }

        return false;
    }

    render() {
        return (
            <div className="test-page-content-inner test-page-comments">
                <h1>Completed Assessment</h1>
                <center>
                    <br />Your assessment is now complete and your administrator has been notified. Thank you for your efforts!
                    <br /><br />
                    <b>Please close your browser now!</b>
                    <br /><br /><br />
                    Thank you,<br />
                    The <i>Cognitive &amp; Personality Profile</i> Team
                    <br /><br />
                    <img src="https://www.profiles.com.au/images/Email_logo.png" alt="CPP logo" />
                    <br /><br />
                    <a href="/Security/Login" class="btn btn-primary">LOG OUT</a>
                    <br /><br />
                 </center>
            </div>
        );
    }
}

function renderOptions(dataField, optionChange) {
    const arr = [];

    for (let i = 1; i <= 5; i++) {
        arr.push(renderOption(dataField, i, optionChange));
    }

    return arr;
}

function renderOption(dataField, optionValue, optionChange) {
    const id = `${dataField}-${optionValue}`;

    return (
<div className="inputGroup" key={id}>
    <input id={id} type="radio" name={dataField} value={optionValue} onChange={() => optionChange(optionValue)} />
    <label htmlFor={id}><span><span /></span></label>
    <span className="option-text">{optionValue}</span>
</div>
    );
}
